import React from "react";
import headerlogo from "../assets/images/ZapMPLogo.png";
// import headerlogo from '../assets/images/zap-bg-logo.png';
import arrow from "../assets/images/icon/arrow_forward_ios.png";
import orangearrow from "../assets/images/icon/orange-down.png";
import dashboard from "../assets/images/icon/dashboard.png";
import employees from "../assets/images/icon/employees.png";
import contractor from "../assets/images/icon/contractor.png";
import benefits from "../assets/images/icon/benefits.png";
import deductions from "../assets/images/icon/deductions.png";
import reports from "../assets/images/icon/reports.png";
import "../styles/main.scss";
import { NavLink } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import routes from "constants/routes";
import { cn, stringMerger } from "utils";
import useApp from "hooks/useApp";

const menuItems = [
  {
    name: "Dashboard",
    icon: dashboard,
    path: "/",
    otherPaths: [
      stringMerger(
        routes.DASHBOARD.HOME,
        routes.DASHBOARD.PAYROLL_TIME_KEEPING.HOME
      ),
      stringMerger(
        routes.DASHBOARD.HOME,
        routes.DASHBOARD.PAYROLL_TIME_KEEPING.HOME,
        routes.DASHBOARD.PAYROLL_TIME_KEEPING.ADD_TIME_CARD
      ),
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.MANAGE_COMPANY),
      stringMerger(routes.DASHBOARD.HOME, routes.DASHBOARD.START_NEW_PAYROLL),
    ],
  },
  {
    name: "Employees",
    icon: employees,
    path: routes.EMPLOYEES.HOME,
    otherPaths: [
      stringMerger(routes.EMPLOYEES.HOME, routes.EMPLOYEES.ADD_EDIT_EMPLOYEE),
      stringMerger(routes.EMPLOYEES.HOME, routes.EMPLOYEES.VIEW),
    ],
  },
  {
    name: "Contractor",
    icon: contractor,
    path: routes.CONTRACTOR.HOME,
    otherPaths: [
      stringMerger(routes.CONTRACTOR.HOME, routes.CONTRACTOR.VIEW),
      stringMerger(
        routes.CONTRACTOR.HOME,
        routes.CONTRACTOR.ADD_EDIT_CONTRACTOR
      ),
    ],
  },
  {
    name: "Benefits",
    icon: benefits,
    path: routes.BENEFITS.HOME,
    otherPaths: [
      stringMerger(
        routes.BENEFITS.HOME,
        routes.BENEFITS.ADD_EDIT_COMPANY_BENEFIT
      ),
      stringMerger(
        routes.BENEFITS.HOME,
        routes.BENEFITS.ADD_EDIT_EMPLOYEE_BENEFIT
      ),
    ],
  },
  {
    name: "Deductions",
    icon: deductions,
    path: routes.DEDUCTIONS.HOME,
    otherPaths: [
      stringMerger(
        routes.DEDUCTIONS.HOME,
        routes.DEDUCTIONS.ADD_EDIT_MCN_DEDUCTION
      ),
      stringMerger(
        routes.DEDUCTIONS.HOME,
        routes.DEDUCTIONS.ADD_EDIT_CHILD_SUPPORT_DEDUCTION
      ),
    ],
  },
  {
    name: "Reports",
    icon: reports,
    path: stringMerger(routes.REPORTS.HOME, routes.REPORTS.ALL_REPORTS),
    otherPaths: [
      stringMerger(routes.REPORTS.HOME),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.AUTHORIZATION_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.COMPANY_TAX_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.CONTRACTOR_TAX_DOCS),
      stringMerger(routes.REPORTS.HOME, routes.REPORTS.EMPLOYEE_TAX_DOCS),
    ],
  },
  // { name: 'Merchant', icon: deductions, path: '/' },
];
const Sidebar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isSidebarOpen } = useApp();

  return (
    <div className={cn("sidebar", isSidebarOpen ? "open" : "closed")}>
      <img className="sidebar-logo" src={headerlogo} alt="Company Logo" />
      <ul className="p-0">
        {menuItems.map((item, index) => (
          <li
            key={index}
            className={`d-flex justify-content-between align-items-center ${
              pathname === item?.path || item?.otherPaths?.includes(pathname)
                ? "active-item"
                : ""
            }`}
          >
            <NavLink
              // to={item.path}
              onClick={() => navigate(item.path)}
              className={({ isActive }) =>
                `d-flex gap-3 ${isActive ? "active" : ""}`
              }
            >
              <img src={item.icon} alt={item.name} />
              <span className={"mx-3"}>{item.name}</span>
            </NavLink>
            <img
              src={item.active ? orangearrow : arrow}
              className="img-fluid arrow-images"
              alt="Arrow"
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Sidebar;
